import store from '@/store/store';
function hasIdentityValue(value) {
    return typeof value === 'string' ? value.trim().length > 0 : value != null;
}
export function getMissingRequiredIdentityFields(meta, paymentMethod) {
    // This is an arbitrary restriction since we only wanted to add support for Bacs only for now.
    // There is no real reason we couldn't do the same for Afterpay.
    if (paymentMethod !== 'bacs_debit') {
        return [];
    }
    return getRequiredFieldsByPaymentMethod(paymentMethod).filter((key) => !hasIdentityValue(meta[key]));
}
export function memberIdentityDataForStripe(identity, values, paymentMethod) {
    const meta = { ...identity.meta };
    for (const key of getMissingRequiredIdentityFields(identity.meta, paymentMethod)) {
        const value = values[key];
        if (hasIdentityValue(value)) {
            meta[key] = value;
        }
        else {
            delete meta[key];
        }
    }
    if (paymentMethod !== 'bacs_debit') {
        delete meta.zip_code;
    }
    return {
        ...meta,
        // Do not allow custom identity fields to overwrite built-in identity fields.
        name: identity.name,
        email: identity.email,
    };
}
export function identityDataForStripe(values, paymentMethod) {
    const [identity] = store.getters['Member/identityWithMeta'];
    if (identity) {
        return memberIdentityDataForStripe(identity, values, paymentMethod);
    }
    else {
        const first = values.first_name;
        const last = values.last_name;
        const result = { ...values };
        if (first && last) {
            // For the purpose of Stripe validation, use regular whitespace character to join the names.
            result.name = `${first} ${last}`;
        }
        return result;
    }
}
const pmRequiredFields = {
    bacs_debit: ['address', 'city', 'country', 'zip_code'],
    afterpay_clearpay: ['address', 'city', 'country', 'zip_code'],
};
export function getRequiredFieldsByPaymentMethod(pm) {
    if (pm) {
        return pmRequiredFields[pm] ?? [];
    }
    return [];
}
